import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Grow } from '@material-ui/core'

import toBottomIcon from '../../../../assets/icons/to-bottom.svg'

class ScrollToBottomButton extends React.Component {
  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    const { classes, display, ...rest } = this.props

    return (
      <Grow in={display}>
        <div className={classes.toBottomIcon} {...rest}>
          <img src={toBottomIcon} alt='to_bottom_-icon' />
        </div>
      </Grow>
    )
  }
}

const styles = {
  toBottomIcon: {
    position: 'fixed',
    right: 16,
    bottom: 16,
    flexShrink: 0,
    display: 'flex',
  },
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = {

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(ScrollToBottomButton)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Button/ScrollToBottomButton.jsx